import React from "react";

import { classnames, Icon } from "@culturehq/components";

const PromptIcon = ({ allowedTypes = "all", className = "" }) => {
  const getIcon = () => {
    switch (allowedTypes) {
      case "just_images":
        return "image";
      case "just_videos":
        return "video-camera-filled-complete";
      default:
        return "images";
    }
  };

  return (
    <div className={classnames("PromptIcon", `${allowedTypes}`, `${className}`)}>
      <Icon icon={getIcon()} />
    </div>
  );
};

export default PromptIcon;
